"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
var axios_1 = __importDefault(require("axios"));
var UserService = (function () {
    function UserService(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        var newAxios = axios_1.default.create({
            baseURL: this.baseUrl,
            headers: {
                Authorization: "Bearer ".concat(token),
                "Content-Type": "application/json",
                "X-profile-Id": profileId
            }
        });
        this.axios = newAxios;
    }
    UserService.prototype.getUserInfo = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v3/users/list";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, {
                                filter: __assign({}, params),
                                range: { limit: 20, offset: 0 },
                                sort: { orderBy: "firstName", orderDir: "ASC" },
                                linkedObjects: true
                            })];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getStudentInto = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, params, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/student/list";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = {
                            filter: {
                                userId: [+userId]
                            },
                            linkedObjects: true
                        };
                        return [4, this.axios.post(url, params)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.searchStudent = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v3/users/list";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, {
                                filter: __assign({}, params),
                                range: { limit: 20, offset: 0 },
                                sort: { orderBy: "firstName", orderDir: "ASC" },
                                linkedObjects: true
                            })];
                    case 2:
                        res = _a.sent();
                        return [2, res.data];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getStudentSignature = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/signatures/my/current";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, {})];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_4 = _a.sent();
                        console.log(error_4);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getStudentInitials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/initials/my/current";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, {})];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_5 = _a.sent();
                        console.log(error_5);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getUserPersonalContacts = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/user-personal-contacts/list";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, params)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_6 = _a.sent();
                        console.log(error_6);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getStudentStaffContact = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/student-staff-contacts/list";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, params)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_7 = _a.sent();
                        console.log(error_7);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getBase64FromUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var res, img, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.axios.get(url, {
                                responseType: "arraybuffer"
                            })];
                    case 1:
                        res = _a.sent();
                        img = Buffer.from(res.data, "binary").toString("base64");
                        return [2, "data:image/png;base64,".concat(img)];
                    case 2:
                        error_8 = _a.sent();
                        console.log(error_8);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    UserService.prototype.updateUserProfile = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v3/users/profiles";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, data)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_9 = _a.sent();
                        console.log(error_9);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.updateUser = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v3/users/edit";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, data)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_10 = _a.sent();
                        console.log(error_10);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.createUser = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v3/users/create";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, data)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_11 = _a.sent();
                        console.log(error_11);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.createProfile = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/profile/create";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios.post(url, data)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_12 = _a.sent();
                        console.log(error_12);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserService.prototype.getNextCustomProfileId = function (params) {
        var _a;
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response, error_13;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, this.axios.post("/v1/users/profile/next-custom-profile-id", params)];
                    case 1:
                        response = _b.sent();
                        return [2, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || {}];
                    case 2:
                        error_13 = _b.sent();
                        console.log("getNextCustomProfileId--errors->>", error_13);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    return UserService;
}());
exports.UserService = UserService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlclNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInNlcnZlci9zZXJ2aWNlcy9Vc2VyU2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdEQUF5QjtBQUV6QjtJQUdJLHFCQUFZLEtBQWEsRUFBRSxTQUEwQjtRQUQzQyxZQUFPLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyx3QkFBd0IsQ0FBQTtRQUVwRCxJQUFNLFFBQVEsR0FBRyxlQUFLLENBQUMsTUFBTSxDQUFDO1lBQzFCLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztZQUNyQixPQUFPLEVBQUU7Z0JBQ0wsYUFBYSxFQUFFLGlCQUFVLEtBQUssQ0FBRTtnQkFDaEMsY0FBYyxFQUFFLGtCQUFrQjtnQkFDbEMsY0FBYyxFQUFFLFNBQVM7YUFDNUI7U0FDSixDQUFDLENBQUE7UUFDRixJQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQTtJQUN6QixDQUFDO0lBRVksaUNBQVcsR0FBeEIsVUFBeUIsTUFBVztRQUFYLHVCQUFBLEVBQUEsV0FBVzs7Ozs7O3dCQUMxQixHQUFHLEdBQUcsZ0JBQWdCLENBQUE7Ozs7d0JBRVosV0FBTSxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUU7Z0NBQ25DLE1BQU0sZUFBTSxNQUFNLENBQUM7Z0NBQ25CLEtBQUssRUFBRSxFQUFDLEtBQUssRUFBRSxFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsRUFBQztnQ0FDN0IsSUFBSSxFQUFFLEVBQUMsT0FBTyxFQUFFLFdBQVcsRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFDO2dDQUM3QyxhQUFhLEVBQUUsSUFBSTs2QkFDdEIsQ0FBQyxFQUFBOzt3QkFMSSxHQUFHLEdBQUcsU0FLVjt3QkFDRixXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7d0JBRXBCLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLG9DQUFjLEdBQTNCLFVBQTRCLE1BQU07Ozs7Ozt3QkFDeEIsR0FBRyxHQUFHLGtCQUFrQixDQUFBOzs7O3dCQUVwQixNQUFNLEdBQUc7NEJBQ1gsTUFBTSxFQUFFO2dDQUNKLE1BQU0sRUFBRSxDQUFDLENBQUMsTUFBTSxDQUFDOzZCQUNwQjs0QkFDRCxhQUFhLEVBQUUsSUFBSTt5QkFDdEIsQ0FBQTt3QkFDVyxXQUFNLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxNQUFNLENBQUMsRUFBQTs7d0JBQXhDLEdBQUcsR0FBRyxTQUFrQzt3QkFDOUMsV0FBTyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksRUFBQTs7O3dCQUVwQixPQUFPLENBQUMsR0FBRyxDQUFDLE9BQUssQ0FBQyxDQUFBOzs7Ozs7S0FFekI7SUFFWSxtQ0FBYSxHQUExQixVQUEyQixNQUFXO1FBQVgsdUJBQUEsRUFBQSxXQUFXOzs7Ozs7d0JBQzVCLEdBQUcsR0FBRyxnQkFBZ0IsQ0FBQTs7Ozt3QkFFWixXQUFNLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRTtnQ0FDbkMsTUFBTSxlQUFNLE1BQU0sQ0FBQztnQ0FDbkIsS0FBSyxFQUFFLEVBQUMsS0FBSyxFQUFFLEVBQUUsRUFBRSxNQUFNLEVBQUUsQ0FBQyxFQUFDO2dDQUM3QixJQUFJLEVBQUUsRUFBQyxPQUFPLEVBQUUsV0FBVyxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUM7Z0NBQzdDLGFBQWEsRUFBRSxJQUFJOzZCQUN0QixDQUFDLEVBQUE7O3dCQUxJLEdBQUcsR0FBRyxTQUtWO3dCQUNGLFdBQU8sR0FBRyxDQUFDLElBQUksRUFBQTs7O3dCQUVmLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUNZLHlDQUFtQixHQUFoQzs7Ozs7O3dCQUNVLEdBQUcsR0FBRyxpQ0FBaUMsQ0FBQTs7Ozt3QkFFN0IsV0FBTSxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLEVBQUE7O3dCQUFwQyxHQUFHLEdBQUcsU0FBOEI7d0JBQzFDLFdBQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUE7Ozt3QkFFcEIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFLLENBQUMsQ0FBQTs7Ozs7O0tBRXpCO0lBQ1ksd0NBQWtCLEdBQS9COzs7Ozs7d0JBQ1UsR0FBRyxHQUFHLCtCQUErQixDQUFBOzs7O3dCQUUzQixXQUFNLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUMsRUFBQTs7d0JBQXBDLEdBQUcsR0FBRyxTQUE4Qjt3QkFDMUMsV0FBTyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksRUFBQTs7O3dCQUVwQixPQUFPLENBQUMsR0FBRyxDQUFDLE9BQUssQ0FBQyxDQUFBOzs7Ozs7S0FFekI7SUFFWSw2Q0FBdUIsR0FBcEMsVUFBcUMsTUFBTTs7Ozs7O3dCQUNqQyxHQUFHLEdBQUcsaUNBQWlDLENBQUE7Ozs7d0JBRTdCLFdBQU0sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxFQUFBOzt3QkFBeEMsR0FBRyxHQUFHLFNBQWtDO3dCQUM5QyxXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7d0JBRXBCLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLDRDQUFzQixHQUFuQyxVQUFvQyxNQUFNOzs7Ozs7d0JBQ2hDLEdBQUcsR0FBRyxpQ0FBaUMsQ0FBQTs7Ozt3QkFFN0IsV0FBTSxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLEVBQUE7O3dCQUF4QyxHQUFHLEdBQUcsU0FBa0M7d0JBQzlDLFdBQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUE7Ozt3QkFFcEIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFLLENBQUMsQ0FBQTs7Ozs7O0tBRXpCO0lBRVksc0NBQWdCLEdBQTdCLFVBQThCLEdBQUc7Ozs7Ozs7d0JBRWIsV0FBTSxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUU7Z0NBQ2xDLFlBQVksRUFBRSxhQUFhOzZCQUM5QixDQUFDLEVBQUE7O3dCQUZJLEdBQUcsR0FBRyxTQUVWO3dCQUNJLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFBO3dCQUM5RCxXQUFPLGdDQUF5QixHQUFHLENBQUUsRUFBQTs7O3dCQUVyQyxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQUssQ0FBQyxDQUFBOzs7Ozs7S0FFekI7SUFFWSx1Q0FBaUIsR0FBOUIsVUFBK0IsSUFBSTs7Ozs7O3dCQUN6QixHQUFHLEdBQUcsb0JBQW9CLENBQUE7Ozs7d0JBRWhCLFdBQU0sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxFQUFBOzt3QkFBdEMsR0FBRyxHQUFHLFNBQWdDO3dCQUM1QyxXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7d0JBRXBCLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLGdDQUFVLEdBQXZCLFVBQXdCLElBQUk7Ozs7Ozt3QkFDbEIsR0FBRyxHQUFHLGdCQUFnQixDQUFBOzs7O3dCQUVaLFdBQU0sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxFQUFBOzt3QkFBdEMsR0FBRyxHQUFHLFNBQWdDO3dCQUM1QyxXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7d0JBRXBCLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLGdDQUFVLEdBQXZCLFVBQXdCLElBQUk7Ozs7Ozt3QkFDbEIsR0FBRyxHQUFHLGtCQUFrQixDQUFBOzs7O3dCQUVkLFdBQU0sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxFQUFBOzt3QkFBdEMsR0FBRyxHQUFHLFNBQWdDO3dCQUM1QyxXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7d0JBRXBCLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLG1DQUFhLEdBQTFCLFVBQTJCLElBQUk7Ozs7Ozt3QkFDckIsR0FBRyxHQUFHLDBCQUEwQixDQUFBOzs7O3dCQUV0QixXQUFNLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsRUFBQTs7d0JBQXRDLEdBQUcsR0FBRyxTQUFnQzt3QkFDNUMsV0FBTyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksRUFBQTs7O3dCQUVwQixPQUFPLENBQUMsR0FBRyxDQUFDLFFBQUssQ0FBQyxDQUFBOzs7Ozs7S0FFekI7SUFFWSw0Q0FBc0IsR0FBbkMsVUFBb0MsTUFBVzs7UUFBWCx1QkFBQSxFQUFBLFdBQVc7Ozs7Ozs7d0JBRXRCLFdBQU0sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQ2xDLDBDQUEwQyxFQUMxQyxNQUFNLENBQ1QsRUFBQTs7d0JBSEssUUFBUSxHQUFHLFNBR2hCO3dCQUNELFdBQU8sQ0FBQSxNQUFBLFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRSxJQUFJLDBDQUFFLElBQUksS0FBSSxFQUFFLEVBQUE7Ozt3QkFFakMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxtQ0FBbUMsRUFBRSxRQUFLLENBQUMsQ0FBQTs7Ozs7O0tBRTlEO0lBQ0wsa0JBQUM7QUFBRCxDQUFDLEFBbEtELElBa0tDO0FBbEtZLGtDQUFXIn0=